import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname,
    });
  }, [location]);
}
export default usePageTracking;